import { v4 as uuidv4 } from 'uuid';

const uuidPrefix = uuidv4().slice(-12);
let counter = 0;

export function generateLoadId(): string {
  return `${uuidPrefix}-${counter++}`;
}
